import * as React from "react";
import { Field, QueryProvider } from "../../../components/context/query";
import { OneClickDownloadChart } from "./charts/OneClickDownloadChart";
import { NavBarChart } from "./charts/NavBarChart";
import { CommonActionChart } from "./charts/CommonActionChart";
import { ShareChart } from "./charts/ShareChart";

interface State {

}

const allowedFields: Field[] = [{
    dataField: 'country',
    caption: 'Country',
    dataType: 'string'
},
{
    dataField: 'city',
    caption: 'City',
    dataType: 'string'
},
{
    dataField: 'membership',
    name: 'has_membership',
    editorOptions: { opened: true },
    caption: 'Has Membership',
    dataType: 'boolean',
    filterOperations: ["="]
},
{
    dataField: 'membership',
    caption: 'Subscription Plan',
    dataType: 'string',
    editorOptions: { opened: true },
    lookup: { dataSource: ['standard', 'premium'] }
},
{
    dataField: 'membership_library',
    caption: 'Subscription Library',
    dataType: 'string',
    editorOptions: { opened: true },
    lookup: { dataSource: [{ val: 'all', label: 'All' }, { val: 'music', label: 'Open Format' }, { val: 'latin', label: 'Latino' }], displayExpr: 'label', valueExpr: 'val' }
},
{
    dataField: 'dj_type',
    caption: 'DJ Type',
    dataType: 'string'
}]

export class ProductClicks extends React.Component<{}, State> {
    render() {
        return <div className="dashboard">
            <div className='charts'>
                <QueryProvider fields={allowedFields}>{({ filter }) => {
                    return <div className='bpm-container'>
                        <div className='row'>
                            <div className='col'>
                                {filter}
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <OneClickDownloadChart />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <NavBarChart />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <CommonActionChart />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <ShareChart />
                            </div>
                        </div>
                    </div>
                }}
                </QueryProvider>
            </div>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/pages/Product/Pages/Clicks.tsx